import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import { cn } from "@/lib/utils";

export const ThemeToggle = ({ className, testid = "theme-toggle-btn" }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={toggle}
      aria-label={dark ? "Switch to light theme" : "Switch to dark theme"}
      title={dark ? "Light mode" : "Dark mode"}
      className={cn(
        "relative w-9 h-9 rounded-full border border-border bg-card grid place-items-center text-foreground/70",
        "hover:text-primary hover:border-primary/50 transition-colors",
        className
      )}
    >
      <Sun
        className={cn("w-4 h-4 absolute transition-opacity duration-200", dark ? "opacity-0" : "opacity-100")}
        strokeWidth={1.8}
      />
      <Moon
        className={cn("w-4 h-4 absolute transition-opacity duration-200", dark ? "opacity-100" : "opacity-0")}
        strokeWidth={1.8}
      />
    </button>
  );
};

export default ThemeToggle;
